import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import type { ReactElement } from "react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import type {
  ContentBasicInfo,
  ContentType,
} from "../../../src/types/contents/contents";
import { getContentList } from "../api";
import { auth } from "../auth";

type ContentListProps = {
  contentType: ContentType;
};

export const ContentList = <T extends ContentBasicInfo>({
  contentType,
}: ContentListProps): ReactElement => {
  const [content, setContent] = useState<T[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      setContent(await getContentList<T>(contentType));
    };

    if (auth.currentUser) void init();
  }, [auth.currentUser]);

  return (
    <Stack>
      <Button onClick={() => navigate(`/${contentType}/new`)}>
        New {contentType}
      </Button>
      {content.map((content) => {
        return (
          <Stack key={content.id}>
            <pre>{JSON.stringify(content, null, 2)}</pre>
            <Button onClick={() => navigate(`/${contentType}/${content.id}`)}>
              Edit
            </Button>
          </Stack>
        );
      })}
    </Stack>
  );
};
